// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  google_maps_api_key: 'AIzaSyCCnOeE2td4pXT5kjRe8OkuhqafV0hG6fQ',
  server: {
    base_url: `https://apisearch.lbb.in/v1`,
    api_key: {
      header: 'x-api-key',
      value: 'NB6nJs2hRD1FznEhO0lS6bDaJ6RvoGR6KksYU9N5'
    }
  },
  places_search: {
    radius: 136263, // In meters
    result_count: 30,
    zoom:14
  },
  toastTimeout: 2000
};



// WEBPACK FOOTER //
// /Users/jaswantsingh/Documents/GitHub/maps/src/environments/environment.ts